import PropTypes from 'prop-types';
import React from 'react';

import propTypes from '../propTypes';
import PageLink from './PageLink';

const ProjectList = ({ projects }) => (
  <>
    {projects.map(project => (
      <PageLink key={project.slug} {...project} />
    ))}
  </>
);

ProjectList.propTypes = {
  projects: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      description: PropTypes.string,
      icon: propTypes.icon,
      image: propTypes.image,
      url: PropTypes.string,
      git: PropTypes.arrayOf(PropTypes.string),
      tags: propTypes.tags,
    }),
  ),
};

ProjectList.defaultProps = {
  projects: [],
};

export default ProjectList;
